import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import minicartQuery from '~/graphql/cart/minicart.gql';
import createNewCartMutation from '~/graphql/cart/createNewCart.gql';
import addProductsToCartMutation from '~/graphql/cart/addProductsToCart.gql';
import addCustomizableProductToCartMutation from '~/graphql/cart/addCustomizableProductToCart.gql';
import updateCartMutation from '~/graphql/cart/updateCart.gql';

function fetchCart(_x, _x2, _x3) {
  return _fetchCart.apply(this, arguments);
}

function _fetchCart() {
  _fetchCart = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(context, reference, token) {
    var data;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return context.app.apolloProvider.defaultClient.query(_objectSpread({
              query: minicartQuery,
              errorPolicy: 'all',
              fetchPolicy: 'network-only'
            }, token && {
              context: {
                headers: {
                  Authorization: "Bearer ".concat(token)
                }
              }
            }, {
              variables: {
                reference: reference
              }
            }));

          case 2:
            data = _context.sent;
            return _context.abrupt("return", data);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchCart.apply(this, arguments);
}

function createCart(_x4, _x5) {
  return _createCart.apply(this, arguments);
}

function _createCart() {
  _createCart = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(context, token) {
    var _ref, data;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return context.app.apolloProvider.defaultClient.mutate(_objectSpread({
              mutation: createNewCartMutation
            }, token && {
              context: {
                headers: {
                  Authorization: "Bearer ".concat(token)
                }
              }
            }));

          case 2:
            _ref = _context2.sent;
            data = _ref.data;
            return _context2.abrupt("return", data);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _createCart.apply(this, arguments);
}

function addCart(_x6, _x7) {
  return _addCart.apply(this, arguments);
}

function _addCart() {
  _addCart = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(context, payload) {
    var response;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return context.app.apolloProvider.defaultClient.mutate(_objectSpread({
              mutation: addProductsToCartMutation
            }, payload.token && {
              context: {
                headers: {
                  Authorization: "Bearer ".concat(payload.token)
                }
              }
            }, {
              variables: {
                cart: payload.cart,
                products: [_objectSpread({
                  reference: payload.reference,
                  quantity: payload.quantity
                }, payload.offer && {
                  offer: payload.offer
                })]
              }
            }));

          case 2:
            response = _context3.sent;
            return _context3.abrupt("return", response);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _addCart.apply(this, arguments);
}

function addCartCustomizable(_x8, _x9, _x10, _x11) {
  return _addCartCustomizable.apply(this, arguments);
}

function _addCartCustomizable() {
  _addCartCustomizable = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(context, cart, token, payload) {
    var _ref2, data;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return context.app.apolloProvider.defaultClient.mutate(_objectSpread({
              mutation: addCustomizableProductToCartMutation
            }, token && {
              context: {
                headers: {
                  Authorization: "Bearer ".concat(token)
                }
              }
            }, {
              variables: {
                cart: cart,
                reference: payload
              }
            }));

          case 2:
            _ref2 = _context4.sent;
            data = _ref2.data;
            return _context4.abrupt("return", data);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _addCartCustomizable.apply(this, arguments);
}

function updateCart(_x12, _x13) {
  return _updateCart.apply(this, arguments);
}

function _updateCart() {
  _updateCart = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee5(context, payload) {
    var _ref3, data;

    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return context.app.apolloProvider.defaultClient.mutate(_objectSpread({
              mutation: updateCartMutation
            }, payload.token && {
              context: {
                headers: {
                  Authorization: "Bearer ".concat(payload.token)
                }
              }
            }, {
              variables: {
                cart: payload.cart,
                items: [{
                  reference: payload.reference,
                  quantity: payload.quantity
                }]
              }
            }));

          case 2:
            _ref3 = _context5.sent;
            data = _ref3.data;
            return _context5.abrupt("return", data);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _updateCart.apply(this, arguments);
}

export { fetchCart, createCart, addCart, updateCart, addCartCustomizable };